import React from 'react'

const Footer = () => {
    return (
        <div className='absolute-center'>
            Made with ❤️ by Rajat Kumar Maharana
        </div>
    )
}

export default Footer